import { api } from "../index";
import { UpdateSenhaData } from "../types";

export const updateAdminPassword = async (
  userId: number,
  currentPassword: string,
  newPassword: string,
  token: string
) => {
  const payload: UpdateSenhaData = {
    senhaAtual: currentPassword,
    novaSenha: newPassword,
  };
  const response = await api.put(
    `/users/${userId}/senha`,
    payload,
    token ? { headers: { "X-CSRF-Token": token } } : undefined
  );
  return response.data;
};
